import ExportForm from "../common/ExportForm";
const EXPORT_COLUMNS = [
	{ key: "requester", label: "Requester" },
	{ key: "department", label: "Department" },
	{ key: "type", label: "Type" },
	{ key: "totalHours", label: "Total Hours" },
	{ key: "fromDate", label: "From Date" },
	{ key: "toDate", label: "To Date" },
	{ key: "notes", label: "Notes" },
	{ key: "status", label: "Status" },
	{ key: "approvalTime", label: "Decision Time" },
	{ key: "approverId", label: "Approver" }, 
	{ key: "approverNotes", label: "Approver Notes" }, 
	{ key: "void", label: "Void" }, 
	{ key: "paid", label: "Paid" }, 
	{ key: "voidReason", label: "Void Reason" }, 
	{ key: "validateReason", label: "Validate Reason" }, 
	{ key: "notifiedBy", label: "Notified By" }, 
	{ key: "notifiedAt", label: "Notified At" }, 
	{ key: "creatorId", label: "Creator" },
	{ key: "updaterId", label: "Updater" }, 
	{ key: "updatedAt", label: "Updated At" }, 
];

export default function TimeOffExportForm(){
	return <ExportForm columns = {EXPORT_COLUMNS}/>;
}